import {
  $applyNodeReplacement,
  DOMConversionMap,
  DOMConversionOutput,
  DOMExportOutput,
  ElementNode,
  LexicalNode,
  LexicalUpdateJSON,
  SerializedElementNode,
} from 'lexical';

export type SerializedNoWrapNode = SerializedElementNode;

export class NoWrapNode extends ElementNode {
  static getType(): string {
    return 'nowrap';
  }

  static clone(node: NoWrapNode): NoWrapNode {
    return new NoWrapNode(node.__key);
  }

  static importJSON(serializedNode: SerializedNoWrapNode): NoWrapNode {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define, no-use-before-define
    return $createNoWrapNode().updateFromJSON(serializedNode);
  }

  static importDOM(): DOMConversionMap | null {
    return {
      span: (node: Node) => {
        const htmlEl = node as HTMLElement;
        if (htmlEl.style?.whiteSpace === 'nowrap') {
          return {
            conversion: (): DOMConversionOutput => ({
              // eslint-disable-next-line @typescript-eslint/no-use-before-define, no-use-before-define
              node: $createNoWrapNode(),
            }),
            priority: 1,
          };
        }

        return null;
      },
    };
  }

  updateFromJSON(serializedNode: LexicalUpdateJSON<SerializedNoWrapNode>): this {
    return super.updateFromJSON(serializedNode);
  }

  exportJSON(): SerializedNoWrapNode {
    return {
      ...super.exportJSON(),
    };
  }

  createDOM(): HTMLElement {
    const element = document.createElement('span');
    element.style.whiteSpace = 'nowrap';

    return element;
  }

  exportDOM(): DOMExportOutput {
    const element = document.createElement('span');
    element.style.whiteSpace = 'nowrap';

    return { element };
  }

  updateDOM(): boolean {
    return false;
  }

  isInline(): boolean {
    return true;
  }

  excludeFromCopy(destination?: string): boolean {
    // Exclude from clipboard copy but NOT from HTML export (used by $generateHtmlFromNodes).
    // Without this, $appendNodesToHTML silently drops the <span style="white-space:nowrap">
    // wrapper and no-wrap styling is lost when saving the RC editor content.
    return destination !== 'clone' && destination !== 'html';
  }
}

export function $createNoWrapNode(): NoWrapNode {
  return $applyNodeReplacement(new NoWrapNode());
}

export function $isNoWrapNode(node: LexicalNode | null): node is NoWrapNode {
  return node instanceof NoWrapNode;
}
